import {ClickAwayListener, ListItemIcon, Paper, Popper} from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import {bool, element, func, node, object, oneOf, oneOfType} from 'prop-types';

import useReport from '../../../../../../hooks/providers/useReport';
import {projectShape} from '../../../../../../proptypes-shapes';
import {getIconComponent} from '../../../../../../utils';

const ReportsList = ({project, isOpen, anchorEl, onClose, handleReportClick}) => {
  const {getReportsListForProject} = useReport();

  const getReportsList = () => {
    const reportsList = getReportsListForProject(project);

    if (reportsList.length === 0) {
      return (
        <MenuItem>
          <ListItemText>Aucun rapport disponible</ListItemText>
        </MenuItem>
      );
    }

    return reportsList.map(r => {
      const IconComponent = getIconComponent(r.icon);

      return (
        <MenuItem key={r.report_id} onClick={() => handleReportClick(r)} sx={{py: 1.5}}>
          <ListItemIcon>
            <IconComponent fontSize="small" />
          </ListItemIcon>
          <ListItemText>{r.report_name}</ListItemText>
        </MenuItem>
      );
    });
  };

  const reportsList = getReportsList();

  return (
    <Popper open={isOpen} anchorEl={anchorEl}>
      <ClickAwayListener onClickAway={onClose}>
        <Paper
          elevation={2}
          sx={{
            borderRadius: 2.5,
            minWidth: 150
          }}
        >
          {reportsList}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

ReportsList.propTypes = {
  project: projectShape.isRequired,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  handleReportClick: func.isRequired,
  anchorEl: oneOfType([object, element, node, oneOf([null])])
};

export default ReportsList;
